export const breakpoints: TBreakpoint = {
  mobile: `(max-width: 990.99px)`,
  desktop: `(min-width: 991px)`,
};

type TBreakpoint = {
  mobile: string;
  desktop: string;
};
